export default __webpack_public_path__ + "static/media/html5.d588cf0d.svg";